import React from "react";
import { Button } from "@chakra-ui/react";
import ITskills from "../../CandProfCreation/CandidateProfileSlice/ITskills/ITskills";
function CandidateSkills() {

  return (
    <div className="">
      <div className="w-full   sm:px-24 py-10  bg-mainBg min-h-screen font-inter">
        <div className="px-4 sm:px-0.5 space-y-8 ">
          {/* <div className="bg-white  rounded-xl shadow-md p-4">
            <div className="flex justify-between w-full items-start ">
              <h2 className="text-2xl font-semibold text-black mb-4">
                IT Skills
              </h2>
              <Button colorScheme="blue">Add Skill</Button>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-gray-50 rounded-lg">
                <thead>
                  <tr className="bg-blue-100 text-gray-700 text-left w-full">
                    <th className="px-6 py-3 font-semibold">Skill Name</th>
                    <th className="px-6 py-3 font-semibold">Experience</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { name: "Computer Network", years: "7 years" },
                    { name: "Operating System", years: "7 years" },
                    { name: "DBMS", years: "7 years" },
                    { name: "TOC", years: "7 years" },
                    { name: "Computer Network", years: "7 years" },
                    { name: "Compiler Design", years: "7 years" },
                  ].map((skill, index) => (
                    <tr
                      key={index}
                      className=" hover:bg-mainBg transition duration-200"
                    >
                      <td className="px-6 py-3 font-medium text-gray-700">
                        {skill.name}
                      </td>
                      <td className="px-6 py-3 text-blue-500 font-semibold">
                        {skill.years}
                      </td>
                      <td className="">
                        <div className="flex gap-2 items-center ">
                          <Button colorScheme="blue">Edit</Button>
                          <div className="">
                            <Button className="" colorScheme="red">
                              <i className="cursor-pointer fa-solid fa-trash-can-arrow-up "></i>
                            </Button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div> */}

          <ITskills />

          <div className="bg-white rounded-xl shadow-md p-4">
            <div className="flex justify-between w-full items-start ">
              <h2 className="text-2xl font-semibold text-black mb-4">
                Basic Skills
              </h2>
              <Button colorScheme="blue">Edit</Button>
            </div>
            <div className="flex flex-wrap gap-3">
              {[
                "Git, GitHub",
                "Content Writing",
                "MS-Excel",
                "SEO",
                "Digital Marketing",
                "Graphic Designing",
                "Social Media Marketing",
              ].map((skill, index) => (
                <div
                  key={index}
                  className="flex items-center border border-gray-300 rounded-lg p-3 bg-gray-50 hover:bg-mainBg transition duration-200"
                >
                  <span className="font-medium">{skill}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CandidateSkills;
